export default __webpack_public_path__ + "static/subfactory-gui-f6ae40646af080e0f450f3f801562f6b.png";